import { Cfa } from "../models/Cfa";

export const CfaContext = new Cfa();
$(() => CfaContext.init());
